enum ENonBenefitSymptomId {
  Hairloss = '9',
  Contraceptive = '10',
  Acne = '11',
  Diet = '12',
  GongJinDan = '109',
  OrientalBeauty = '605',
  OtherOrientalTreatments = '610',
}

export enum EDeprecatedCategoryType {
  Symptom = 'symptom',
  Subject = 'subject',
}

export enum ECategoryType {
  Treatment = 'treatment',
  Department = 'department',
}

export default class DiagnosisCategoryService {
  static getDiagnosisCategoryType = (deprecatedType: EDeprecatedCategoryType): ECategoryType => {
    switch (deprecatedType) {
      case EDeprecatedCategoryType.Subject:
        return ECategoryType.Department;
      case EDeprecatedCategoryType.Symptom:
        return ECategoryType.Treatment;
    }
  };

  static getDeprecatedCategoryType = (categoryType: ECategoryType): EDeprecatedCategoryType => {
    switch (categoryType) {
      case ECategoryType.Department:
        return EDeprecatedCategoryType.Subject;
      case ECategoryType.Treatment:
        return EDeprecatedCategoryType.Symptom;
    }
  };

  static isNonBenefitCategory(type?: ECategoryType, categoryId?: string): boolean {
    if (!type || !categoryId) {
      return false;
    }
    switch (type) {
      case ECategoryType.Treatment: {
        switch (categoryId) {
          case ENonBenefitSymptomId.Hairloss:
          case ENonBenefitSymptomId.Acne:
          case ENonBenefitSymptomId.Contraceptive:
          case ENonBenefitSymptomId.Diet:
          case ENonBenefitSymptomId.GongJinDan:
          case ENonBenefitSymptomId.OrientalBeauty:
          case ENonBenefitSymptomId.OtherOrientalTreatments:
            return true;
          default:
            return false;
        }
      }
      case ECategoryType.Department: {
        return false;
      }
    }
  }
}
